<template>
  <div class="modal">
    <van-popup
      :class="[goActiveFlag ? 'dialogPopTransform' : '', 'dialogPop']"
      v-model="showModal"
      :close-on-click-overlay="closeFnValue"
    >
      <div class="popKid" v-show="showModal">
        <img
          v-show="showKid"
          src="../../assets/images/game/pop-kid.png"
          alt=""
        />
      </div>
      <div class="modal-dialog">
        <div
          class="close-icon"
          v-on:click="$emit('cancel', 2)"
          v-if="showClsoeBtn"
        ></div>
        <div class="modal-top">
          <slot name="top"></slot>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div
          class="modal-footer1"
          v-if="btnType == 1"
          v-on:click="$emit('submit')"
        >
          <a href="javascript:;" class="btn">{{ sureText }}</a>
        </div>
        <div
          class="modal-footer1"
          v-if="btnType == 3"
          v-on:click="$emit('cancel', 1)"
        >
          <a href="javascript:;" class="btn">{{ cancelText }}</a>
        </div>
        <div class="modal-footer2" v-if="btnType == 2">
          <div class="btn-all">
            <!-- <a href="javascript:;" :style="{width:(this.ifHasVideo?'50%':'100%')}" class="btn1" v-on:click="$emit('cancel')">{{cancelText}}</a>
                    <a href="javascript:;" v-if="ifHasVideo" class="btn2" v-on:click="$emit('submit')">{{sureText}}</a> -->
            <a href="javascript:;" class="btn1" v-on:click="$emit('cancel', 1)">
              <img
                src="../../assets/images/test-center/over.png"
                alt=""
                v-if="showImg"
              />
              {{ cancelText }}
            </a>
            <a href="javascript:;" class="btn2" v-on:click="$emit('submit')">
              <img
                src="../../assets/images/test-center/continue.png"
                alt=""
                v-if="showImg"
              />
              {{ sureText }}
            </a>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "modal",
  components: {},
  props: {
    showClsoeBtn: {
      type: Boolean,
      default: true,
    },
    goActiveFlag: {
      type: Boolean,
      default: false,
    },
    ifHasVideo: {
      type: Boolean,
      default: true,
    },
    closeFnValue: {
      type: Boolean,
      default: true,
    },
    // 按钮类型: 1:确定按钮 2：取消按钮 3：确定
    btnType: String,
    // 是否展示小人
    showKid: Boolean,
    //是否展示按钮图片
    showImg: Boolean,
    sureText: {
      type: String,
      default: "确定",
    },
    cancelText: {
      type: String,
      default: "取消",
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    listenFn() {
      this.$bus.$on("closeModal", (val) => {
        this.showModal = val;
      });
    },
    // 开启弹框
    openDialog() {
      this.showModal = true;
    },
    //关闭弹框
    closeDialog() {
      this.showModal = false;
    },
  },
  beforeCreate() {},
  created() {
    this.listenFn();
  },
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    this.$bus.$off("closeModal");
  },
  destroyed() {},
};
</script>

<style lang="scss">
.dialogPop {
  overflow-y: visible !important;
}
.modal {
  position: relative;
  .van-overlay {
    z-index: 333333333 !important;
  }
  .dialogPopTransform {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    -webkit-transform-origin: 40% -25%;
    transform-origin: 40% -25%;
  }
  .dialogPop {
    z-index: 3333333334 !important;
  }
  .popKid {
    position: absolute;
    top: -63px;
    right: 0px;
    z-index: 3000;
    img {
      width: 56px;
    }
  }
  .van-popup {
    border-radius: 15px;
    .modal-dialog {
      position: relative;
      width: 315px;
      // border: 1px solid red;
      display: flex;
      flex-direction: column;
      align-items: center;
      // min-height: 183px;
      border-radius: 15px;
      .close-icon {
        position: absolute;
        right: 17px;
        top: 17px;
        width: 12px;
        height: 12px;
        background: url("../../assets/images/parent-course/close.png") no-repeat;
        background-size: cover;
      }
      .modal-top {
        margin-top: 40px;
        margin-bottom: 10px;
        p {
          color: #333;
          height: 22px;
          line-height: 22px;
          font-size: 18px;
        }
      }
      .modal-body {
        padding: 0 30px;
        height: auto;
        // border: 1px solid red;
        margin-bottom: 40px;
        p {
          font-size: 14px;
          color: #666;
        }
      }
      .modal-footer1 {
        height: 50px;
        width: 100%;
        border-radius: 0 0 10px 10px;
        // border: 1px solid red;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--btn-backgruond-color);
        a {
          color: white;
        }
      }
      .modal-footer2 {
        height: 50px;
        width: 100%;
        .btn-all {
          height: 100%;
          a {
            height: 100%;
            width: 50%;
            display: inline-block;
            text-align: center;
            line-height: 50px;
            &.btn1 {
              color: #666;
              background-color: #f2f2f2;
              font-size: 14px;
              border-radius: 0px 0px 0px 15px;
              img {
                width: 65px;
                height: 58px;
                margin-top: -18px;
              }
            }
            &.btn2 {
              font-size: 14px;
              color: #fff;
              background: var(--btn-backgruond-color);
              border-radius: 0px 0px 15px 0px;
              img {
                width: 65px;
                height: 58px;
                margin-top: -15px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
